import { render, staticRenderFns } from "./secVideo3.vue?vue&type=template&id=7af5a5d5&scoped=true&"
var script = {}
import style0 from "./secVideo3.vue?vue&type=style&index=0&id=7af5a5d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af5a5d5",
  null
  
)

export default component.exports